(function iframeContentHandler(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (!global.NewHomeSource.FullImageViewerState ||
    !global.NewHomeSource.FullImageViewer.Config ||
    !global.NewHomeSource.Pipe) {
    return;
  }

  const previousIframeContentHandler = global.NewHomeSource.IframeContentHandler;
  const iframeContainer = global.document.createElement('DIV');
  const iframeElement = global.document.createElement('IFRAME');
  let imagesContainer = global.document.createElement(global
    .NewHomeSource.FullImageViewer.Config.imagesContainer);

  if (!imagesContainer) {
    return;
  }

  /**
  * @private
  * replaceSpecialCharactersFromEmbedCode: replaces ASCII codes of a string, in concrete: <, >, '.
  * @param {string} embedCode is the string where we want to replace special characters from.
  */
  function replaceSpecialCharactersFromEmbedCode(embedCode) {
    if (!embedCode) {
      return '';
    }

    const replaceableStrings = {
      '&amp;': '',
      'lt;': '<',
      'gt;': '>',
      '#39;': '\'',
      'quot;': '\'',
    };

    const getReplaceableValue = function getReplaceableValue(char) {
      return replaceableStrings[char] || '';
    };

    return embedCode.replace(/&amp;|lt;|gt;|#39;|quot;/g, getReplaceableValue);
  }

  /**
  * @private
  * getEmbededCodeSource: return the embed code src.
  * @param {string} embedCode is the embedCode we need to return as an element.
  */
  function getEmbededCodeSource(embedCode) {
    if (!embedCode) {
      return undefined;
    }

    const embedCodeWithoutAsciiCharacters = replaceSpecialCharactersFromEmbedCode(embedCode);
    return embedCodeWithoutAsciiCharacters.replace(/.*src='(.*?)'.*/g, '$1');
  }

  /**
   * @private
   * resizeFrameDimensions: sets the new width and height.
   *
   * @param {object} data with the information regarding the new boundaries.
   */
  function resizeFrameDimensions(data) {
    iframeElement.setAttribute('width', data.width);
    iframeElement.setAttribute('height', data.height);
  }

  /**
   * @private
   * handleResize: checks if the topic message indicates a resize action is needed.
   *
   * @param {object} data information that was changed.
   * @param {string} topic that was triggered by the Event Bus.
   */
  function handleResize(data, topic) {
    if (topic !== 'onResize') {
      return;
    }

    requestAnimationFrame(resizeFrameDimensions.bind(null, data));
  }

  /**
  * @constructs NewHomeSource.IframeContentHandler
  */
  function IframeContentHandler() {
  }

  /**
   * @private
   * updateSandboxAttribute: sets or removes the sandbox iframe attribute. This attribute is needed for resources
   * like matterports, but non needed for other kind of resources like pdf, that is why we set or remove this
   * based on the media type.
   *
   * @param {object} element iframe where the rich media type is going to be shown.
   * @param {object} data contains the information related to the current rich media resource.
   */
  function updateSandboxAttribute(element, data) {
    if (global.NewHomeSource.FullImageViewer.Config.isDisplayInSandBoxCollection(data)) {
      if (global.NewHomeSource.FullImageViewer.Config.isMediShownInCarousel) {
        element.setAttribute('sandbox', 'allow-same-origin allow-scripts allow-forms allow-popups');
        return;
      }

      element.setAttribute('sandbox', 'allow-same-origin allow-scripts allow-top-navigation allow-forms');
    } else {
      element.removeAttribute('sandbox');
    }
  }

  /**
   * @public
   * update: this method will be called by the Event Bus when the data is updated.
   *
   * @param {object} data information that was changed.
   */
  IframeContentHandler.update = function update(data, topic) {
    if (topic === 'onResize') {
      handleResize(data, topic);
      return;
    }

    imagesContainer = global.document.querySelector(global.NewHomeSource.FullImageViewer.Config.queryImagesContainer);

    if (!data.IsFrame || !imagesContainer) {
      if (iframeContainer) {
        iframeContainer.innerHTML = '';
      }

      imagesContainer.classList.add('player-box');

      return;
    }

    const alreadyExistingIframe = imagesContainer.querySelector('iframe');
    if (alreadyExistingIframe) {
      alreadyExistingIframe.parentElement.remove();
    }

    let iFrameSource = getEmbededCodeSource(data.EmbedCode);
    if (!iFrameSource) {
      iFrameSource = data.Source;
    }

    updateSandboxAttribute(iframeElement, data);
    iframeElement.src = iFrameSource;
    iframeElement.alt = data.Alt;
    iframeElement.onload = () => {
      imagesContainer.classList.remove('player-box');
    };

    if (global.NewHomeSource.FullImageViewer.Config.isMediShownInCarousel) {
      iframeElement.style.height = 'inherit';
    }

    iframeContainer.prepend(iframeElement);
    imagesContainer.prepend(iframeContainer);
    iframeContainer.classList.add('player-box__iframe-box');
  };

  /**
  * @public
  *
  * noConflict: Returns control of NewHomeSource.IframeContentHandler to the previous script.
  */
  IframeContentHandler.noConflict = function noConflict() {
    global.NewHomeSource.IframeContentHandler = previousIframeContentHandler;
    return IframeContentHandler;
  };

  global.NewHomeSource.FullImageViewerState.add('onImageSet', IframeContentHandler);
  global.NewHomeSource.FullImageViewerState.add('onResize', IframeContentHandler);
  global.NewHomeSource.IframeContentHandler = IframeContentHandler;
}(window));
